import PropTypes from 'prop-types';
import {JssProvider, ThemeProvider} from 'react-jss';
import {connect} from 'react-redux';
import BaseStyleWrapper from './BaseStyleWrapper';

import CheckoutApp from './CheckoutApp';
import getJSS from './getJSS';
import CheckoutOverlayProvider from './v2/components/CheckoutOverlay/CheckoutOverlayProvider';

const jss = getJSS();

export function ThemedApp(props) {
  return (
    <JssProvider jss={jss}>
      <ThemeProvider theme={props.theme}>
        <BaseStyleWrapper>
          <CheckoutApp />
          <CheckoutOverlayProvider />
        </BaseStyleWrapper>
      </ThemeProvider>
    </JssProvider>
  );
}

ThemedApp.propTypes = {
  // Theme is going to have to be an object I'm afraid.
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  theme: state.theme,
});

export default connect(mapStateToProps)(ThemedApp);
